import { useEffect, useRef, useState } from "react";
import VisitorsViewModel from "../../viewmodels/visitorsLog/VisitorsViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { formatDate, withRouter } from "../../shared/utility";
import EmptyModal from "../../components/modals/EmptyModal";
import AuditActionLink from "../../components/audit/AuditActionLink";
import AuditHistoriesLink from "../../components/audit/AuditHistoriesLink";
import OperationalDataTableSkeleton from "../../components/operational/OperationalDataTableSkeleton";
import { Paginator } from "primereact/paginator";
import FilterDropdown from "../../components/filterDropdown/FilterDropdown";
import { useNavigate } from "react-router-dom";

function Visitors(props) {
  const { logout, addSnackbar } = props;
  const navigate = useNavigate();
  const {
    askDeleteVisitor,
    emptyModal,
    loading,
    setEmptyModelOpen,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    visitors,
    getVisitors,
  } = VisitorsViewModel(logout, addSnackbar);

  var currentPage = 1;
  useEffect(() => {
    getVisitors(null, currentPage, filters);
  }, []);

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const searchRef = useRef();

  const handleSearch = () => {
    getVisitors(searchRef.current.value, 1, filters);
  };

  const handlePagination = (event) => {
    currentPage = event.page + 1;
    setFirst(event.first);
    setRows(event.rows);
    getVisitors(searchRef.current.value, currentPage, filters);
  };

  return (
    <div>
      <div className="mt-2">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold leading-6 text-gray-900">
                Visitors
              </h1>
              <div className="mt-5 flex rounded-md">
                <div className="relative flex items-stretch flex-grow focus-within:z-10">
                  <input
                    type="search"
                    name="searchVisitors"
                    id="searchVisitors"
                    className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                    placeholder="Search by name or company"
                    ref={searchRef}
                    onKeyDown={(e) =>
                      e.key === "Enter" ? handleSearch() : null
                    }
                  />
                </div>
                <button
                  type="button"
                  className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                  onClick={() => handleSearch()}
                >
                  <MagnifyingGlassIcon
                    className="h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </button>

                <div className="ml-3 flex items-center gap-3">
                  <button
                    type="button"
                    className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600"
                    onClick={() => navigate("/visitors/new")}
                  >
                    Create
                  </button>

                  <FilterDropdown
                    actionCall={() =>
                      getVisitors(searchRef.current.value, 1, filters)
                    }
                    filterComponents={filterComponents}
                    resetFilters={() => {
                      resetFilters();
                    }}
                    showFilters={showFilters}
                    setShowFilters={setShowFilters}
                  />
                  <AuditHistoriesLink slug="visitor-log" />
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                {loading ? (
                  <OperationalDataTableSkeleton
                    columns={[
                      "#",
                      "Name",
                      "Email",
                      "Company",
                      "Visited At",
                      "Actions",
                    ]}
                    rows={8}
                  />
                ) : (
                  <div className="overflow-hidden card-custom">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-white">
                        <tr>
                          <th className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                            #
                          </th>
                          <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                            Name
                          </th>
                          <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                            Email
                          </th>
                          <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                            Company
                          </th>
                          <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                            Visited At
                          </th>
                          <th className="relative py-3 pl-3 pr-4 sm:pr-6"></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {visitors.data && visitors.data.length > 0 ? (
                          visitors.data.map((v, index) => (
                            <tr key={v.id}>
                              <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                {v.id}
                              </td>
                              <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                                {v.name}
                              </td>
                              <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                                {v.email}
                              </td>
                              <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                                {v.company}
                              </td>
                              <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                                {formatDate(v.checked_in_date)}
                              </td>
                              <td className="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                <button
                                  className="ml-2 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600"
                                  onClick={() => navigate(`/visitors/${v.id}`)}
                                >
                                  Edit
                                </button>
                                <AuditActionLink
                                  slug="visitor-log"
                                  id={v.id}
                                  name={v.name}
                                  className="ml-2"
                                />
                                <button
                                  onClick={() => {
                                    askDeleteVisitor(v, index);
                                  }}
                                  className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="whitespace-nowrap py-3 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-center"
                              colSpan={6}
                            >
                              No visitors found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="w-full">
                <Paginator
                  first={first}
                  rows={rows}
                  totalRecords={visitors.total}
                  onPageChange={handlePagination}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Visitors),
);
